

import { useMemo } from 'react';
import { cloneDeep, slice } from 'lodash';

const useStatsGroupedByRating = (stats, showArrows, showStartBar, showEndBar) => {
    return useMemo(() => {
        const statsArray = stats ? Object.entries({ ...stats }) : [];
        let prevItem = {}; // אתחול של prevItem
        let groupedStats = statsArray.reduce((acc, [key, value]) => {
            let rating = value.rating_index?.toString();
            if (!rating) {
                rating = prevItem.rating;
            }
            if (!acc[rating]) {
                acc[rating] = { items: [], count: 0, percent: 0, rating_index: rating };
            }
            acc[rating].count += value.count;
            acc[rating].percent += value.percent;
            acc[rating].items.push({ key, ...value });
            prevItem = { rating: value.rating_index, key: key };

            return acc;
        }, {});


        let nGroupedStats = cloneDeep(groupedStats)

        if (showArrows) {
            if (!showStartBar)
                if (nGroupedStats[5]) {
                    nGroupedStats[5].items = slice(nGroupedStats[5].items, -10); // שומר רק את 10 האחרונים
                }
            if (!showEndBar)
                if (nGroupedStats[1]) {
                    nGroupedStats[1].items = slice(nGroupedStats[1].items, 0, 10); // שומר רק את 10 הראשונים
                }

        }

        return nGroupedStats;
    }, [stats, showArrows, showStartBar, showEndBar]); // תלויות עבור useMemo
};

export default useStatsGroupedByRating;